"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinalResult = exports.getNonfinalResult = exports.empty = void 0;
exports.empty = {
    type: 'error',
    error: 'EMPTY',
};
function getNonfinalResult(result) {
    const { max, fee, feePerByte, bytes, totalSpent } = result.result;
    return {
        type: 'nonfinal',
        fee: fee.toString(),
        feePerByte: feePerByte.toString(),
        bytes,
        max,
        totalSpent,
    };
}
exports.getNonfinalResult = getNonfinalResult;
function getFinalResult(result, transaction) {
    const { max, fee, feePerByte, bytes, totalSpent } = result.result;
    return {
        type: 'final',
        fee: fee.toString(),
        feePerByte: feePerByte.toString(),
        bytes,
        transaction,
        max,
        totalSpent,
    };
}
exports.getFinalResult = getFinalResult;
